import React from 'react'
import { node, string, func, bool } from 'prop-types'
import classnames from 'classnames'

const Button = ({
  onClick,
  text,
  children,
  active,
  mainClass = 'react-btn',
  activeClass = 'react-btn--active',
  customClasses = '',
  withIcon,
  linkButton,
  ...rest
}) => {
  const classes = classnames({ [mainClass]: true, [activeClass]: active, 'react-btn--with-icon': withIcon })
  const props = { className: `${classes} ${customClasses}`, onClick, ...rest }
  return linkButton ? <a {...props}>{children}</a> : <button {...props}>{children}</button>
}

Button.propTypes = {
  customClasses: string,
  text: string,
  mainClass: string,
  activeClass: string,
  withIcon: bool,
  active: bool,
  linkButton: bool,
  onClick: func,
  children: node
}

export default Button